/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */
import React, {useEffect, useState} from "react"
import axios from "axios";
import BASEURL from "../../Constants";
import {ToastContainer} from "react-toastify";
import {Link} from "react-router-dom";

const Home = () => {
    const [revenue, setRevenue] = useState([]);
    const getRevenue = () => {
        axios.get(BASEURL + '/api/provider/revenue').then(res => {
            setRevenue(res.data)
        })
    }
    useEffect(() => {
        getRevenue()
    }, []);

    return (
        <main>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="container-fluid px-4">
                <h1 className="mt-4">Provider Dashboard</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Revenue Details</li>
                </ol>
                <div className="my-card">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="card bg-warning">
                                <div className="card-header">
                                    <h5>Total Order Amount</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.total_order_amount}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card bg-success">
                                <div className="card-header">
                                    <h5>Paid Order Amount</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.paid_order_amount}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card bg-info">
                                <div className="card-header">
                                    <h5>Total Paid Order</h5>
                                </div>
                                <div className="card-body">
                                    <h1>{revenue.total_paid_order}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-info">
                                <div className="card-header">
                                    <h5>Total Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.total_revenue}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-success">
                                <div className="card-header">
                                    <h5>Paid Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <h1>${revenue.paid_revenue}</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-4">
                            <div className="card bg-danger">
                                <div className="card-header">
                                    <h5>Due Revenue</h5>
                                </div>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h1>${revenue.due_revenue}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
export default Home
